<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('sales_order_title') }}
                <v-spacer></v-spacer>
                <v-btn
                    class="mx-1"
                    icon
                    v-if="hasSelectedSalesOrder && authorizations.sales_orders.read"
                    @click="openSalesOrderDisplayDialog">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn
                    class="mx-1"
                    icon
                    @click="getSalesOrders()">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu offset-y :close-on-content-click="false" v-model="display.search">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <SalesOrderSearchMenu :loading="loading.data" :close="!loading.data" @submit="SalesOrderSearchMenuSubmit" />
                </v-menu>
                <!-- <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        autofocus
                        :label="$t('search')"
                        solo
                        v-model="search"
                        @keypress.enter="getSalesOrders()"
                        hide-details>
                    </v-text-field>
                </v-menu> -->

                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            :disabled="authorizations.sales_orders ? !authorizations.sales_orders.create : true"
                            @click="openSalesOrderDialog({ editMode: false })"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="authorizations.sales_orders ? !authorizations.sales_orders.create : true">mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_sales_order') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider v-if="hasSelectedSalesOrder"></v-divider>
                        <v-list-item
                            v-if="hasSelectedSalesOrder && authorizations.sales_orders.read"
                            @click="openSalesOrderDisplayDialog"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_sales_order') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="openSalesOrderEditDialog"
                            v-if="hasSelectedSalesOrder && authorizations.sales_orders ? authorizations.sales_orders.update : false"
                            :disabled="!editableSalesOrder"
                            link>
                            <v-list-item-icon>
                                <v-icon  :disabled="!editableSalesOrder">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_sales_order') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="hasSelectedSalesOrder && authorizations.sales_orders ? authorizations.sales_orders.delete : false"
                            :disabled="!deletableSalesOrder"
                            @click="openSalesOrderDeleteDialog"
                            link>
                            <v-list-item-icon>
                                <v-icon  :disabled="!deletableSalesOrder">mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_sales_order') }}</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <SalesOrdersDataTable
                    ref="salesOrdersDataTable"
                    :loading="loading.data"
                    :salesOrders="salesOrders"
                    :length="length.salesOrders"
                    :pagination="true"
                    @updated="getSalesOrders"
                    @selected:row="setSelectedSalesOrder"
                    @selected:clear="clearSelectedSalesOrder"
                    />
                <!-- <v-data-table
                    @item-selected="$emit('salesorder-item-selected')"
                    dense
                    show-select
                    single-select
                    :options.sync="options"
                    :loading="loading.data"
                    :items="salesOrders"
                    :server-items-length="salesOrdersLength"
                    :headers="headers.salesOrder"
                    v-model="selected.salesOrder">
                    <template v-slot:[`item.validity_date`]="{ item }">
                        <v-chip small :color="getColor(item.validity_date)" dark>{{ item.validity_date }}</v-chip>
                    </template>
                    <template v-slot:[`item.total`]="{ item }">
                        {{ formatMoney(item.total, "SDG ", 2) }}
                    </template>
                    <template v-slot:[`item.delivered`]="{ item }">
                        {{ formatNumber(item.delivered, 2) }}
                    </template>
                    <template v-slot:[`item.remaining`]="{ item }">
                        {{ formatNumber(item.remaining, 2) }}
                    </template>
                    <template v-slot:[`item.extended`]="{ item }">
                        {{ formatNumber(item.extended, 2) }}
                    </template>
                    <template v-slot:[`item.state`]="{ item }">
                        <v-chip small :color="item.state == 'CLOSED' ? 'error' : 'success' " dark>{{ item.state }}</v-chip>
                    </template>
                </v-data-table> -->
            </v-card-text>
        </v-card>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <SalesOrderDialog
            @submit="getSalesOrders()"
            ref="salesOrderDialog"/>
        <!-- <DeleteSingleDialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <SalesOrderDisplayDialog
            ref="salesOrderDisplayDialog"
            @updated="onSalesOrderDisplayDialogUpdated"/> -->
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
// import DeleteSingleDialog from '@/components/common/DeleteSingleDialog';
// import AlertDialog from '@/components/common/AlertDialog';
// import SalesOrderDialog from '@/components/Sales/SalesOrderDialog';
// import SalesOrderDisplayDialog from '@/components/Sales/SalesOrderDisplayDialog';
import { mapActions, mapState } from 'vuex';
import SalesOrdersDataTable from '../../components/Sales/SalesOrdersDataTable';
import {isEmpty} from 'lodash';
import SalesOrderDialog from '../../components/Sales/SalesOrderDialog';
import SalesOrderSearchMenu from "../../components/Sales/SalesOrderSearchMenu";
import {getSalesOrders} from '../../services/sales/salesOrder'
// import {formatMoney, formatNumber} from 'accounting';

export default {
    name: 'SalesOrders',
    components: {
        RetryDialog,
        // SalesOrderDialog,
        // DeleteSingleDialog,
        // AlertDialog,
        // SalesOrderDisplayDialog,
        SalesOrdersDataTable,
        SalesOrderDialog,
        SalesOrderSearchMenu,
    },
    data() {
        return {
            salesOrders: [],
            length: {
                salesOrders: 0
            },
            loading: {
                data: false,
                // salesOrder: false
            },
            selected: {
                salesOrder: {}
            },
            // dateChack: new Date().toISOString().substr(0, 10),
            // headers: {
            //     salesOrder: [
            //         { text: this.$t('code'),  value: "code" },
            //         { text: this.$t('date'), value: "date" },
            //         { text: this.$t('validity_date'), value: "validity_date" },
            //         { text: this.$t('customer'), sortable: false, value: "customer" },
            //         { text: this.$t('delivered'), sortable: false, value: "delivered" },
            //         { text: this.$t("extended"), sortable: false, value: "extended" },
            //         { text: this.$t('remaining'), sortable: false, value: "remaining" },
            //         { text: this.$t('total'), sortable: false, value: "total" },
            //         { text: this.$t('state'), sortable: false, value: "state" }
            //     ]
            // },
            search: null,
            options: {},
            display: {
                search: false,
            }
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        getSelectedSalesOrder() {
            return this.selected.salesOrder;
        },
        hasSelectedSalesOrder() {
            return !isEmpty(this.selected.salesOrder);
        },
        editableSalesOrder() {
            return this.selected.salesOrder.meta.editable;
        },
        deletableSalesOrder() {
            return this.selected.salesOrder.meta.deletable;
        }
    },
    watch: {
        // options: {
        //     handler () {
        //         this.createdDataFetch();
        //     },
        //     deep: true
        // }
    },
    methods: {
        // formatMoney,
        // formatNumber,
        ...mapActions("sales/salesOrder", ["fetchSalesOrders"]),
        // getColor (data) {
        //     if (data >= this.dateChack) return 'green'
        //     else if (data > this.dateChack) return 'orange'
        //     else return 'red'
        // },
        async getSalesOrders(options = {current_page: 1, itemsPerPage: 10}) {
            try {
                this.loading.data = true;
                this.options = { ...this.search, ...options };
                let result = await this.fetchSalesOrders(this.options);
                this.salesOrders = result.data.data;
                this.length.salesOrders = result.data.total;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"getSalesOrders",message});
            }
        },
        setSelectedSalesOrder(salesOrder) {
            this.selected.salesOrder = salesOrder;
        },
        clearSelectedSalesOrder() {
            this.selected.salesOrder = {};
        },
        openSalesOrderDialog(params){
            this.$refs.salesOrderDialog.open(params);
        },
        // openDeleteDialog(params) {
        //     this.$refs.salesOrdersDataTable.openSalesOrderDeleteDialog(this.getSelectedSalesOrder.id);

        // },
        openSalesOrderDisplayDialog() {
            this.$refs.salesOrdersDataTable.openSalesOrderDisplayDialog(this.getSelectedSalesOrder.id);
        },
        openSalesOrderEditDialog() {
            this.$refs.salesOrdersDataTable.openSalesOrderEditDialog({editMode: true, id: this.getSelectedSalesOrder.id});
        },
        openSalesOrderDeleteDialog() {
            this.$refs.salesOrdersDataTable.openSalesOrderDeleteDialog();
        }
        // refreshDataFetch() {
        //     this.search = null;
        //     this.createdDataFetch();
        // },
        // onDeleteDialogSubmit(params) {
        //     if(params.target == 'salesOrder') {
        //         this.removeSalesOrder(params)
        //             .then(() => {
        //                 this.$refs.deleteSingleDialog.close();
        //                 this.createdDataFetch();
        //                 this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
        //             })
        //             .catch((error) => {
        //                 this.$refs.deleteSingleDialog.close();
        //                 let message = error.response ? error.response.data.message : error;
        //                 this.$refs.alertDialog.open({type: "error", message});
        //             })
        //     }
        // },
        ,onRetryDialogSubmit(params){
            if(params.target == "getSalesOrders") {
                if(params.retry) this.getSalesOrders();
            }
        },
        // onSalesOrderDisplayDialogUpdated() {
        //     this.createdDataFetch();
        // }
        async SalesOrderSearchMenuSubmit(search) {
            this.loading.data = true;
            this.search = search;
            // console.log('Sales order search menu submit', this.options);
            let response = await getSalesOrders({...this.options, ...this.search});
            this.salesOrders = response.data.data;
            this.length.salesOrders = response.data.total;
            this.loading.data = false;
        }
    },
    created() {
        // this.getSalesOrders({itemsPerPage: 10});
    }
}
</script>